<template>
  <table class="bonus-card-transaction-table">
    <thead class="bonus-card-transaction-table__head">
      <tr class="bonus-card-transaction-table__row">
        <th>Дата</th>
        <th>Тип начисления</th>
        <th>Бонусы</th>
      </tr>
    </thead>
    <tbody class="bonus-card-transaction-table__body">
      <tr
        v-for="transaction in transactions"
        :key="transaction.id"
        class="bonus-card-transaction-table__row"
      >
        <td data-label="Дата">{{ transaction.createdAt }}</td>
        <td data-label="Тип начисления">{{ transaction.sourceType }}</td>
        <td data-label="Бонусы">{{ transaction.amount }} Б</td>
      </tr>
    </tbody>
  </table>
</template>

<script>

export default {
  /**
   * @description Таблица транзакций бонусной карты
   */
  name: 'BonusCardTransactionTable',
  props: {
    /**
     * @description Транзакции
     * @type {Array<Transaction>}
     */
    transactions: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.bonus-card-transaction-table {
  width: 100%;
  border-collapse: collapse;
  th, td {
    text-align: left;
  }
}

@media screen and (max-width: 480px) {
  table, tbody {
    display: block;
  }
  .bonus-card-transaction-table {
    &__head {
      display: none;
    }
    &__row {
      display: grid;
      grid-template-columns: 1fr;
      gap: 10px;
    }
    td {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      text-align: right;
      &:before {
        content: attr(data-label);
        margin-right: 20px;
        font-weight: 700;
        text-align: left;
      }
    }
  }
}
</style>
